<template>
  <div class="content">
    <div class="message-box">
      <div class="message-header">
        <van-icon :name="type" :color="typeColor" size="3rem"/>
        <div class="message-title">{{detail.xiaoxileibie}}</div>
        <div class="message-title-desc">如遇其他问题，请联系客户</div>
      </div>
      <div class="divider-show"><van-divider /></div>
      <div class="message-content">
        <div class="first-content" :style="{color:`${firstContent.color}`}">{{firstContent.value}}</div>
        <div v-for="(item,key) in keywordContent" :key="key">
          <div class="keyword-content">
            <div class="keyword-title"><span>{{item.ziduanmingcheng}}：</span></div>
            <div class="keyword-message" :style="{color:`${item.color}`}"><span>{{item.value}}</span></div>
          </div>
        </div>
        <div class="remark-content"><span>备注：</span><span :style="{color:`${remarkContent.color}`}">{{remarkContent.value}}</span></div>
      </div>
      <div class="divider-show"><van-divider /></div>
      <div v-if="tourl"><van-button type="primary" block :url="tourl">点击查看</van-button></div>
    </div>
  </div>
</template>
<script>
import api from '@/fetch/api'
import { Toast } from "vant"
export default {
  data() {
    return {
      id:0,
      messageDetail:[],
      firstContent:[],
      remarkContent:[],
      keywordContent:[],
      tourl:"",
      type:"info",
      typeColor:"#4775d8",
      detail:[],
    }
  },
  created()
  {
    var id = this.$route.params.id;
    this.id = id;
    this.getNotificationDetail(id);
    //this.deal_data_template();
  },
  methods:{
    deal_data_template(objectA,objectB)
    {
      var keywordArr = {};
      for(var key in objectA){
        for (var i = 0; i < objectB.length; i++) {
          if(objectB[i].qushumingcheng == key)
          {
            objectA[key].ziduanmingcheng = objectB[i].ziduanmingcheng;
            if(key.indexOf('keyword')>=0)
            {
              keywordArr[key] = objectA[key];
            }
          }
        }
      }
      objectA['keyword'] = keywordArr;
      return objectA;
    },
    getNotificationDetail(id){
      var that = this;
      //var weburl = that.GLOBAL.weburl;
      api.getNotificationDetail(id).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var detail = res.data;
          that.detail = detail;
          var messageObj = JSON.parse(detail.messjson);
          var messageDetail = messageObj.data;
          var ltxtXtWxmessmbList = detail.ltxtXtWxmessmbList;
          var messageArr = that.deal_data_template(messageDetail,ltxtXtWxmessmbList);

          that.firstContent = messageArr.first;
          that.remarkContent = messageArr.remark;
          that.keywordContent = messageArr.keyword;
          that.tourl = detail.tourl?detail.tourl:"";
          var wxmobanid = detail.wxmobanid;
          switch (true) {
            case (wxmobanid.indexOf("success")>=0):
              that.type = "checked";
              that.typeColor = "#4775d8";
            break;
            case (wxmobanid.indexOf("error")>=0):
              that.type = "clear";
              that.typeColor = "#ff0000";
            break;
            default:
            that.type = "info";
            that.typeColor = "#4775d8";
          }
        }
      }).catch(function() {
        Toast.fail('连接失败，请刷新页面');
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.content{
  margin-top: 1rem;
  background: #fff;
  padding-bottom: 2rem;
  .message-box{
    margin:0 auto;
    padding: 0 1rem;
    .message-header{
      padding-top: 2rem;
      text-align: center;
      .message-title{
        padding-top: 1rem;
        font-weight: 600;
        font-size: 1rem;
      }
      .message-title-desc{
        padding-top: .5rem;
        color: #808080;
      }

    }
    .message-content{
      margin-top: 1rem;
      font-size: .875rem;
      line-height: 2;
      .first-content{
        word-wrap: break-word;
        word-break:break-all;
        padding: 0 1.5rem;
        color: #808080;
      }
      .keyword-content{
        padding: 0 auto;
        // word-wrap: break-word;
        // word-break: break-all;
        overflow: hidden;
        .keyword-title{
          float: left;
          color: #808080;
          width: 40%;
          text-align: left;
          span{
            margin-left: 2rem;
          }
        }
        .keyword-message{
          float: left;
          width: 60%;
          span{
            margin-right: 2rem;
          }
        }
      }
      .remark-content{
        word-wrap: break-word;
        word-break:break-all;
        padding: 0 1.5rem;
        color: red;
        span{
          color: #808080;
          padding-right: 1rem;
        }

      }
    }
  }
}
</style>
